import axios from "axios";
import { Icon } from "../models/Icon";
import { Response } from "../models/Response";

export class ManagedListsService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = `${process.env.VUE_APP_FORMS_API}/managed-lists`;
  }

  async getIconsImages(
    type: string
  ): Promise<Response<Icon[] | string[] | void>> {
    return (await axios.get(`${this.baseUrl}/${type}`)).data;
  }
}
